import * as React from "react";

export interface LoaderProp {
    message?: string
}

export class Loader extends React.Component<LoaderProp> {
    render() {
        const name = this.props.message || "読込中";
        return (
            <React.Fragment>
            <div className="loadingio-spinner-spin-fw0j98w8hbv">
                <div className="ldio-bbcq3s0aspk">
                    <div>
                        <div/>
                    </div>
                    <div>
                        <div/>
                    </div>
                    <div>
                        <div/>
                    </div>
                    <div>
                        <div/>
                    </div>
                    <div>
                        <div/>
                    </div>
                    <div>
                        <div/>
                    </div>
                    <div>
                        <div/>
                    </div>
                    <div>
                        <div/>
                    </div>
                </div>
            </div>
                {name}
            </React.Fragment>
        )
    }
}
